export const APIHOST = {
    local: "http://localhost:3000/dev",
    development: "https://p7336ckdd5.execute-api.ap-northeast-2.amazonaws.com/dev",
    production: "https://api.bandiburri.com",
};
export const APIHOSTNOW = APIHOST[process.env.NODE_ENV];
